import React from "react";

import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import { ListItemIcon, ListItemText, Menu, MenuItem, MenuItemProps, MenuProps } from "@mui/material";
import { PsychologyReverse } from "assets/material-custom-icons";
import { Notice } from "components/Prompts/Notice";
import { DocumentSectionType } from "constants/documents";
import { useIsViewerPermission, usePrompt, useRoleGuardHook } from "hooks";
import { DocumentSection } from "store/types/documents";

import { RoleName } from "../../../constants";

interface Props extends MenuProps {
  onShare: () => void;
  onDelete: () => void;
  onAskAi?: () => void;
  section?: DocumentSection;
}
export const QuestionSectionContextMenu = (props: Props) => {
  const { onShare, onDelete, onAskAi, section, hidden, ...menuProps } = props;
  if (hidden) return null;

  const menuItemsProps: MenuItemProps["sx"] = {
    "&:hover": {
      backgroundColor: "#DBE8F5"
    }
  };

  // const onDuplicateRole = useRoleGuardHook(onDuplicate, [RoleName.Admin, RoleName.Analyst]);
  const onShareRole = useRoleGuardHook(onShare, [RoleName.Admin, RoleName.Analyst]);
  // const onMultiShareRole = useRoleGuardHook(onMultiShare, [RoleName.Admin, RoleName.Analyst]);
  const onDeleteRole = useRoleGuardHook(onDelete, [RoleName.Admin, RoleName.Analyst]);

  const onAskAiRole = onAskAi && useRoleGuardHook(onAskAi, [RoleName.Admin, RoleName.Analyst]);
  const isAnalystViewerPermission = useIsViewerPermission("file_upload");
  const openPrompt = usePrompt();

  const handleUploadFilesClick = () => {
    if (isAnalystViewerPermission) {
      openPrompt({ Component: Notice, props: { type: "trial" } });
      return;
    }
    onAskAiRole && onAskAiRole();
  };

  return (
    <Menu {...menuProps}>
      <MenuItem
        onClick={() => {
          onShareRole && onShareRole();
        }}
        sx={menuItemsProps}
      >
        <ListItemIcon>
          <PersonAddAltIcon fontSize="md" sx={{ fill: "#0a3142" }} />
        </ListItemIcon>
        <ListItemText>Share</ListItemText>
      </MenuItem>
      {onAskAiRole && (
        <MenuItem
          disabled={section?.ai_status === "in-progress"}
          onClick={handleUploadFilesClick}
          sx={menuItemsProps}
        >
          <ListItemIcon>
            <PsychologyReverse fontSize="md" sx={{ fill: "#0a3142" }} />
          </ListItemIcon>
          <ListItemText>
            {section?.type === DocumentSectionType.AIQuestion && section?.ai_files?.length
              ? "Edit Files"
              : "Upload Files"}
          </ListItemText>
        </MenuItem>
      )}
      <MenuItem
        onClick={() => {
          onDeleteRole && onDeleteRole();
        }}
        sx={menuItemsProps}
      >
        <ListItemIcon>
          <DeleteOutlineIcon fontSize="md" sx={{ fill: "#0a3142" }} />
        </ListItemIcon>
        <ListItemText>Delete</ListItemText>
      </MenuItem>
    </Menu>
  );
};
